/**
 * The shop's premium-fantasy skin (m9). The owner found the shop "too childish" — its icons and the effect of the
 * display font — so the shop screens wear a premium look (Cinzel + Alegreya Sans, aged gold and blued steel on vellum,
 * engraved plates, wax seals, calm motion) while every other screen keeps the Keep & Plate kit.
 *
 * A shop root carries this class: the Deals sheet and its choosers / odds / receipt, the VIP page, the Shops screen
 * (Merchant, Event, VIP), the Chests & Shop sheet, the Market, and the purchase confirms they open. The skin itself is
 * CSS only: styles/shopskinKit.css redefines the kit's tokens on the root and re-targets the kit rules under it,
 * styles/shopskinScreens.css does the same for the shop screens' own rules.
 */
import "./styles/s3.css";

/**
 * Shop redesign (owner 2026-10-19: "the rest of the game is light and friendly, then with the shop we've gone really
 * dark"): the shop roots now wear `s3`, Kingshot's light shop look in the game's own Keep & Plate kit (styles/s3.css):
 * Lilita and Nunito, the parchment sheet with folder tabs, items on rarity-coloured squares, a pale price strip, bright
 * banners. The premium skin's stylesheets stay in the tree for one release but no root carries `.shopskin` any more.
 */
export const SHOP_SKIN = "s3";
